import { Component, computed, EventEmitter, inject, Input, Output, signal } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { type NavItem } from '../../layouts.interface';
import { TranslatePipe } from '@ngx-translate/core';
import { SessionService } from '../../../core/auth/session-service';

@Component({
  selector: 'app-sidebar',
  imports: [RouterLink, RouterLinkActive, MatIconModule, TranslatePipe],
  templateUrl: './app-sidebar.html',
  styleUrl: './app-sidebar.css',
})
export class AppSidebar {
  private sessionService = inject(SessionService);
  private _menuItems = signal<NavItem[]>([]);

  @Input({ required: true })
  set menuItems(value: NavItem[]) {
    this._menuItems.set(value);
  }

  @Output() itemSelected = new EventEmitter<void>();

  @Output() logoutClick = new EventEmitter<void>();

  readonly visibleItems = computed(() => {
    return this._menuItems().filter((item) => this.isAllowed(item));
  });
  toggle(item: NavItem): void {
    item.expanded = !item.expanded;
  }

  onLeafItemClick(): void {
    this.itemSelected.emit();
  }
  isAllowed(_navItem: NavItem) {
    return _navItem.allowedRoles ? this.sessionService.hasAnyRole(_navItem.allowedRoles) : true;
  }

  onLogout() {
    this.logoutClick.emit();
  }
}
